import React, { useMemo } from 'react';
import { CardStatusReportIcon } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportTypeKeys } from '../../report.types';
import ReportCardBase, { ReportCardBaseProps } from '../ReportCardBase';

import { useCardStatusBriefQuery } from './queries';

interface Props extends ReportCardBaseProps {}

const TEST_ID = 'card-status-report-report-card';
const CardStatusCard: React.FC<Props> = ({ isFavoriteMode }) => {
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();
  const isSystem = useMemo(() => type === OrganizationTypes.system, [type]);

  const {
    data: { active, pending },
    isLoading,
  } = useCardStatusBriefQuery();
  const childrenNode = useMemo(() => {
    if (!isSystem) {
      return (
        <ReportCardBase.DescriptionBase
          isLoading={isLoading}
          title="Card activation"
          testId={TEST_ID}
          items={[
            {
              label: 'Active',
              value: `${active || 0}`,
            },
            {
              label: 'Pending',
              value: `${pending || 0}`,
            },
          ]}
        />
      );
    }
    return null;
  }, [active, isLoading, isSystem, pending]);
  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.CardStatus);

  return (
    <ReportCardBase
      // isUpdated
      isWideMode={isFavoriteMode}
      testId={TEST_ID}
      url={ROUTES.CARD_STATUS_REPORT}
      isFavorite={isFavorite}
      onChangeFavorite={handleToggleReportKey}
      icon={
        <CardStatusReportIcon
          size={isFavoriteMode ? '50px' : '40px'}
          color={isFavoriteMode ? 'iconAccent' : 'iconDisabled'}
        />
      }
      title="Card Status"
      description="Track participant card mailing,
activation status, and dependent card details"
    >
      {childrenNode}
    </ReportCardBase>
  );
};
export default CardStatusCard;
